module.exports = __webpack_public_path__ + "media/svg-new/heartOff-866c418f.svg";